import { IBudgetVersionService } from '../../../../models/budgetV2';

// Services may come without `id`, so they are matched by package code/name.
export const findProposalService = (
  proposalServices: IBudgetVersionService[] | undefined,
  service: IBudgetVersionService
): IBudgetVersionService | undefined =>
  (proposalServices ?? []).find((proposal) =>
    (!!service.code && proposal.code === service.code) || (!!service.name && proposal.name === service.name)
  );
